// Club sin MYKLUBB: una org tipo club administrada por una organizadora (organizations.
// administrada_por, migracion 20261008_clubes_sin_myklubb). No tiene usuarios.
// null = no es administrada; '' = lo es, pero su organizadora no esta en la lista.
export const nombreAdministradora = (org, orgs = []) => {
  if (!org?.administrada_por) return null
  const dueña = orgs.find((o) => o.id === org.administrada_por)
  return dueña?.name || ''
}

// "Entrar" (impersonar desde Platform Admin) solo tiene sentido en un club que opera en esta
// app: no en una organizadora (vive en Torneos) ni en un club administrado, que no tiene
// usuarios ni acceso a la app (spec 2026-10-08 §8.5). Entrar a uno dejaria apagar sus casillas.
export const ofreceEntrar = (org) =>
  !!org && !['league', 'tournament_organizer'].includes(org.type) && !org.administrada_por
